export const GET_ALL_PRODUCTS_REQUEST = 'products/GET_ALL_PRODUCTS_REQUEST';
export const GET_ALL_PRODUCTS_SUCCESS = 'products/GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_FAILURE = 'products/GET_ALL_PRODUCTS_FAILURE';

//on single product page
export const GET_SINGLE_PRODUCT_REQUEST = 'products/GET_SINGLE_PRODUCT_REQUEST';
export const GET_SINGLE_PRODUCT_SUCCESS = 'products/GET_SINGLE_PRODUCT_SUCCESS';
export const GET_SINGLE_PRODUCT_FAILURE = 'products/GET_SINGLE_PRODUCT_FAILURE';


export const GET_AUTHOR_PRODUCT_REQUEST = 'products/GET_AUTHOR_PRODUCT_REQUEST';
export const GET_AUTHOR_PRODUCT_SUCCESS = 'products/GET_AUTHOR_PRODUCT_SUCCESS';
export const GET_AUTHOR_PRODUCT_FAILURE = 'products/GET_AUTHOR_PRODUCT_FAILURE';


//for admin only
export const ADD_PRODUCT_REQUEST = 'products/ADD_PRODUCT_REQUEST';
export const ADD_PRODUCT_SUCCESS = 'products/ADD_PRODUCT_SUCCESS';
export const ADD_PRODUCT_FAILURE = 'products/ADD_PRODUCT_FAILURE';

//for admin only
export const UPDATE_PRODUCT_REQUEST = 'products/UPDATE_PRODUCT_REQUEST';
export const UPDATE_PRODUCT_SUCCESS = 'products/UPDATE_PRODUCT_SUCCESS';
export const UPDATE_PRODUCT_FAILURE = 'products/UPDATE_PRODUCT_FAILURE';

//for admin only
export const DELETE_PRODUCT_REQUEST = 'products/DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_SUCCESS = 'products/DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_FAILURE = 'products/DELETE_PRODUCT_FAILURE';